import React, { useState, useEffect, useRef } from "react";
import "./VarahaLoading.css";
import { subscribeToCategories } from "../firebase/categories";
import { subscribeToProducts } from "../firebase/firestore";

const desktopVideo = "/assets/varaha animation.mp4";
const mobileVideo = "/assets/home loading video.mp4";

export default function VarahaLoading() {
  const [isMobile, setIsMobile] = useState(false);
  const videoRef = useRef(null);
  const dataPreloadedRef = useRef(false);

  useEffect(() => {
    // Check if device is mobile
    const checkMobile = () => {
      const isMobileDevice = window.innerWidth <= 768 || 
                            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setIsMobile(isMobileDevice);
    };

    // Check on mount
    checkMobile();

    // Listen for resize events
    window.addEventListener('resize', checkMobile);

    // Preload critical data during loading screen using persistent cache
    // This ensures data is ready instantly when loader finishes
    let unsubscribeCategories = null;
    let unsubscribeProducts = null;
    
    if (!dataPreloadedRef.current) {
      dataPreloadedRef.current = true;
      
      // Start subscriptions early - they'll load from cache instantly
      // This happens in the background while the video plays
      unsubscribeCategories = subscribeToCategories(() => {
        // Categories loaded from cache - ready instantly
      });
      
      unsubscribeProducts = subscribeToProducts(() => {
        // Products loaded from cache - ready instantly
      });
    }

    // Cleanup subscriptions and event listeners when component unmounts
    return () => {
      if (unsubscribeCategories) unsubscribeCategories();
      if (unsubscribeProducts) unsubscribeProducts();
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  // Optimize video loading for faster playback
  useEffect(() => {
    if (videoRef.current) {
      // Set video properties for faster loading
      videoRef.current.load();
      
      // Try to play immediately (may be blocked by browser autoplay policy)
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Autoplay was prevented, but that's okay - video will play when user interacts
        });
      }
    }
  }, [isMobile]);

  return (
    <div
      className="varaha-loading"
      role="status"
      aria-busy="true"
      aria-label="Loading • Varaha Silks"
    >
      <video
        ref={videoRef}
        className="varaha-video"
        autoPlay
        muted
        loop
        playsInline
        preload="none"
        loading="lazy"
        key={isMobile ? 'mobile' : 'desktop'}
      >
        <source src={isMobile ? mobileVideo : desktopVideo} type="video/mp4" />
      </video>
    </div>
  );
}
